function Footer() {
  return (
    <footer className="footer">
      <p className="footer__copyright">&#169; 2022 Mesto Russia</p>
    </footer>
  )
}

export default Footer;